var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPedidosVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.008,
    height: 20,
    viewBox: "0 0 20.008 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 20.008,
    height: 20,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.008,
    height: 20,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36D896",
    fillRule: "evenodd",
    d: "M16.2999878 9.9699707c-.35125733.63739014-1.02224732 1.03234864-1.75 1.0300293H7.1000061L6 13h12v2H6c-.70855713.00036621-1.3644104-.37420654-1.72409058-.98468018C3.91619873 13.4048462 3.90634155 12.6496582 4.25 12.0300293l1.3500061-2.44000244L2 2H0V0h3.26998901l.94000245 2h14.8000183c.35186768.00256348.67651368.18988037.85482789.4932251.1783142.30334472.18408203.67810058.01516723.98675537L16.2999878 9.9699707zM17.30999755 4H5.16000366l2.36999512 5h7.02001953l2.75997925-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36D896",
    fillRule: "evenodd",
    d: "M6 16c-1.1045695 0-2 .8954305-2 2s.8954305 2 2 2 2-.8954305 2-2-.8954305-2-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36D896",
    fillRule: "evenodd",
    d: "M16 16c-1.1045695 0-2 .8954305-2 2s.8954305 2 2 2 2-.8954305 2-2-.8954305-2-2-2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedidosVerde);
export default __webpack_public_path__ + "static/media/pedidos_verde.f79561629bb489843b95ae6add9392f5.svg";
export { ForwardRef as ReactComponent };